import api from '../../api'
import * as types from '../../types'

export default {
  state: {
    applyDate: '',
    itemApplyId: '',
    loanAmount: '',
    auditState: '',
    custName: '',
    custLicense: '',
    loanSdate: '',
    loanEdate: '',
    yearRate: '',
    yearRateConsulting: '',
    repayType: '',
    repayTypeZxf: '',
    loanExpires: '',
    bankAccountInfo: '',
    canRepayPeriod: '',
    canRepayAdvanced: '',
    totalPages: '',
    pageCount: '',
    frontApplyA: '',
    managerFullName: '',
    managerMobile: '',
    managerEmail: '',
    managerPicture: 10001137700000,
    itemContractSigned: '',
    identify: '',
    repayInfoList: [],
    frontApplyState: '',
    enterpriseNumber: '',
    advRePayState: ''
  },
  getters: {
    [types.GET_LOAN_INFO_DETAIL] (state) {
      return {
        applyDate: state.applyDate,
        advRePayState: state.advRePayState,
        loanAmount: state.loanAmount,
        auditState: state.auditState,
        custName: state.custName,
        custLicense: state.custLicense,
        loanSdate: state.loanSdate,
        loanEdate: state.loanEdate,
        yearRate: state.yearRate,
        yearRateConsulting: state.yearRateConsulting,
        repayType: state.repayType,
        repayTypeZxf: state.repayTypeZxf,
        loanExpires: state.loanExpires,
        bankAccountInfo: state.bankAccountInfo,
        canRepayPeriod: state.canRepayPeriod,
        canRepayAdvanced: state.canRepayAdvanced,
        totalPages: state.totalPages,
        frontApplyA: state.frontApplyA,
        managerFullName: state.managerFullName,
        managerMobile: state.managerMobile,
        managerEmail: state.managerEmail,
        managerPicture: state.managerPicture,
        itemContractSigned: state.itemContractSigned,
        identify: state.identify,
        repayInfoList: state.repayInfoList ? state.repayInfoList : [],
        pageCount: state.pageCount,
        itemApplyId: state.itemApplyId,
        frontApplyState: state.frontApplyState,
        enterpriseNumber: state.enterpriseNumber
      }
    }
  },
  actions: {
    [types.GET_LOAN_ALL_DATA]: ({commit}, params) => api.getMyLoanDetail(params),
    [types.SIGN_AGREEMENT]: ({commit}, params) => api.signAgreement(params),
    [types.DOWN_AGREEMENT]: ({commit}, params) => api.downAgreement(params)
  },
  mutations: {
    [types.SET_LOAN_ALL_DATA] (state, data) {
      state.applyDate = data.applyDate
      state.advRePayState = data.advRePayState
      state.loanAmount = data.loanAmount
      state.auditState = data.auditState
      state.custName = data.custName
      state.custLicense = data.custLicense
      state.loanSdate = data.loanSdate
      state.loanEdate = data.loanEdate
      state.yearRate = data.yearRate
      state.yearRateConsulting = data.yearRateConsulting
      state.repayType = data.repayType
      state.repayTypeZxf = data.repayTypeZxf
      state.loanExpires = data.loanExpires
      state.bankAccountInfo = data.bankAccountInfo
      state.canRepayPeriod = data.canRepayPeriod
      state.canRepayAdvanced = data.canRepayAdvanced
      state.totalPages = data.totalPages
      state.frontApplyA = data.frontApplyA
      state.managerFullName = data.managerFullName
      state.managerMobile = data.managerMobile
      state.managerEmail = data.managerEmail
      state.managerPicture = data.managerPicture
      state.itemContractSigned = data.itemContractSigned
      state.identify = data.identify
      state.repayInfoList = data.repayInfoList
      state.pageCount = data.pageCount
      state.itemApplyId = data.itemApplyId
      state.frontApplyState = data.frontApplyState
      state.enterpriseNumber = data.enterpriseNumber
    },
    [types.SET_SIGNED] (state, data) {
      state.itemContractSigned = data.itemContractSigned
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/loanDetail.js